// Flag to know if the print preview is on.
let printing = false;
window.addEventListener("beforeprint", () => {
  printing = true;
});
window.addEventListener("afterprint", () => {
  printing = false;
});
/**
 * Fires a callback whenever the element's width changes.
 * @param {HTMLElement} element
 * @param {Function} callback
 * @return A ResizeObserver instance.
 */

const onWidthResize = (element, callback) => {
  const widthChangeObserver = new ResizeObserver(entries => {
    const entry = entries[0];
    /**
     * We don't want the callback to fire when the print preview is on, as we want to avoid
     * the printed page looking different than what the user sees on the page.
     */

    if (!printing) {
      // eslint-disable-next-line callback-return
      callback(entry.contentRect.width);
    }
  });
  widthChangeObserver.observe(element);
  return widthChangeObserver;
};

export default onWidthResize;